import { PerimetersAndCosts, stampCosts } from '../../constants/stamp-costs'
import { StampShapes } from '../../types/api/stamp'

export interface StampSpecs {
    shape: StampShapes
    floods: number
    width: number
    length: number
    labelsInFlood: number
}

/**
 * Расчитывает стоимость штампа правильной формы
 *
 * ТАКАЯ ЖЕ ФУНКЦИЯ НА БЭКЕ!!!!! ЕСЛИ ПРАВКИ, ТО ПРАВИТЬ И ТУ!!!
 *
 * @param specs - спецификации штампа
 * @returns стоимость штампа
 */
export default function calcStampCost(specs: StampSpecs): number {
    // TODO: тут не должно быть проверок, они должны быть выше, функция должна только считать по заполенным данным
    if (!areSpecsValid(specs)) return 0

    const { shape, floods, width, length, labelsInFlood } = specs
    const numberOfLabels = getNumberOfLabels(floods, labelsInFlood)
    const perimeter = getPerimeter(shape, width, length)
    const perimetersAndCosts = getPerimetersAndCosts(numberOfLabels)
    const initialCost = getInitialCost(perimetersAndCosts, perimeter)
    const coefOfIncrease = 0.36
    const costOfIncrease = initialCost * coefOfIncrease
    const cost = initialCost + costOfIncrease

    return cost
}

export function getNumberOfLabels(floods: number, labelsInFlood: number) {
    return floods * labelsInFlood
}

export function getPerimeter(shape: StampShapes, width: number, length: number) {
    switch (shape) {
        case 'Квадрат':
            return getPerimeterOfRectShapes(width, length)
        case 'Прямоугольный':
            return getPerimeterOfRectShapes(width, length)
        case 'Круг':
            return getPerimeterOfRoundShapes(width, length)
        case 'Овал':
            return getPerimeterOfRoundShapes(width, length)
        default:
            return 0
    }
}

export function getPerimeterOfRoundShapes(width: number, length: number): number {
    return 2 * Math.PI * Math.sqrt((width * width + length * length) / 8)
}

export function getPerimeterOfRectShapes(width: number, length: number): number {
    return (width + length) * 2
}

export function getPerimetersAndCosts(numberOfLabels: number): PerimetersAndCosts {
    return stampCosts[numberOfLabels - 1]
}

export function getInitialCost(
    perimetersAndCosts: { [key: string]: string } | undefined | null,
    perimeter: number
): number {
    if (perimetersAndCosts == null || typeof perimetersAndCosts !== 'object') {
        return 0
    }
    // получаем массив числовых ключей и сортируем его по возрастанию
    const keys = Object.keys(perimetersAndCosts)
        .map(Number)
        .sort((a, b) => a - b)

    // находим первый ключ >= n
    const foundKey = keys.find(key => key >= perimeter)

    // если такой ключ есть — возвращаем значение, иначе undefined
    return foundKey !== undefined ? +perimetersAndCosts[String(foundKey)] : 0
}

export function areSpecsValid(specs: StampSpecs): boolean {
    const { shape, floods, width, length, labelsInFlood } = specs

    if (!shape || !floods || !width || !length || !labelsInFlood || shape === 'Фигурный') {
        return false
    }

    return true
}
